module.exports = __webpack_public_path__ + "img/visuels_audit_slideshow-auto.6708640b.png";